export const AlertMessageModalConstant = {
    //INVALID AIRTEL NUMBER
    INVALID_AIRTEL_NUMBER: 'Please enter a valid airtel mobile number.',
    //OTP ERROR MESSAGES
    DAILY_LIMIT_EXCEEDED: 'Daily limit exceeded, please login tomorrow',
    ALTERNATE_NUMBER_OTP_ERROR: 'OTP can not be sent to alternate number.',
    OTHER_NUMBER_OTP_ERROR: 'OTP can not be sent, please try with some other airtel number',
    INVALID_OTP: 'Please enter a valid OTP.',
    INCORRECT_OTP: 'Incorrect OTP limit exceeded. Please try after some time.',
    INCORRECT_RESPONSE: 'Something went wrong. Please try again.',
    //DEFAULT ERROR MESSAGE
    DEFAULT_ERROR: 'Some error ocurred, please try again',
    RESEND_LIMIT_EXCEEDED: 'Resend limit exceeded. Please try after some time.'
};